import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';
import * as momentImported from 'moment';
const moment = momentImported;

@Component({
  selector: 'ihm-time-field',
  templateUrl: './ihm-time-field.component.html',
  styleUrls: ['./ihm-time-field.component.scss']
})
export class IhmTimeFieldComponent implements OnInit {
  time: any;
  hoursList: Array<string>;
  minutesList: Array<string>;
  amPmList: Array<string>;
  @Input() fieldLabel: string = 'Time';
  @Input() shortTimeFormat: boolean = false;
  @Input() hoursInterval: number = 1;
  @Input() minutesInterval: number = 1;
  @Output() timeChanged = new EventEmitter();
  @Input() showTime: any;

  constructor() {}

  ngOnInit() {
    this.hoursList = this.getHoursList(this.hoursInterval);
    this.minutesList = this.getMinutesList(this.minutesInterval);
    this.amPmList = this.getAmPmList();

    // Initializes time field with the current time.
    this.time = {
      hour: moment().format('hh'),
      minute: this.minutesInterval === 1 ? moment().format('mm') : '00',
      ampm: moment().format('A')
    };
    if (this.showTime != null) {
      this.time = this.showTime;
    }

    this.emitTimeChanged();
  }

  private getHoursList(interval: number): Array<string> {
    const hoursList: Array<string> = [];

    for (let i = 1; i <= 12; i++) {
      if (i % interval === 0) {
        hoursList.push(_.padStart(i.toString(), 2, '0'));
      }
    }

    return hoursList;
  }

  private getMinutesList(interval: number): Array<string> {
    const minutesList: Array<string> = [];

    for (let i = 0; i < 60; i++) {
      if (i % interval === 0) {
        minutesList.push(_.padStart(i.toString(), 2, '0'));
      }
    }

    return minutesList;
  }

  private getAmPmList(): Array<string> {
    return ['AM', 'PM'];
  }

  private getMomentTime() {
    return moment(`${this.time.hour}:${this.time.minute} ${this.time.ampm}`, 'hh:mm A');
  }

  private getTimeFormat(): string {
    if (this.shortTimeFormat) {
      return this.getShortTimeFormat();
    }

    return this.getMomentTime().format('hh:mm A');
  }

  private getShortTimeFormat(): string {
    if (this.time.minute === '00') {
      return this.getMomentTime().format('ha');
    }

    return this.getMomentTime().format('h:mma');
  }

  emitTimeChanged(): void {
    this.timeChanged.emit(this.getTimeFormat());
  }

  increase(list: any, time: any, property: string): void {
    const index = _.indexOf(list, time[property]);

    if (!_.isNil(list[index + 1])) {
      time[property] = list[index + 1];
    } else {
      time[property] = _.first(list);
    }

    this.emitTimeChanged();
  }

  decrease(list: Array<any>, time: any, property: string): void {
    const index = _.indexOf(list, time[property]);

    if (!_.isNil(list[index - 1])) {
      time[property] = list[index - 1];
    } else {
      time[property] = _.last(list);
    }

    this.emitTimeChanged();
  }
}
